import { actionGenerator, IReduxAction } from '../../utils/actions';

export const RELOAD_BET_POSITION = 'BET_POSITION :: RELOAD_BET_POSITION';

export type TReloadBetPositionAction = IReduxAction<typeof RELOAD_BET_POSITION>;

export const reloadBetPosition = actionGenerator<typeof RELOAD_BET_POSITION>(RELOAD_BET_POSITION);
